import React, { Component } from "react";
import { Accordion, AccordionHeader, AccordionBody } from "design-react-kit";
import { MSection, Title } from "components/misc";
import { ContactRequestForm } from "components/forms";

export class ContactBox extends Component {
  defaultState = {
    collapseOpen1: false,
    collapseOpen2: false,
    collapseOpen3: false,
    collapseOpen4: false,
  };

  state = {
    ...this.defaultState,
  };

  componentDidMount() {}

  toggle = (id) => {
    this.setState({
      ...this.defaultState,
      [`collapseOpen${id}`]: !this.state[`collapseOpen${id}`],
    });
  };

  render() {
    const { collapseOpen1, collapseOpen2, collapseOpen3, collapseOpen4 } = this.state;
    const aa = process.env.REACT_APP_AA_YEAR;

    return (
      <MSection className="my-4">
        <Title>CONTATTACI PER INFORMAZIONI</Title>
        <Accordion>
          <AccordionHeader active={collapseOpen1} onToggle={() => this.toggle(1)}>
            <span className="text-green">Email</span>
          </AccordionHeader>
          <AccordionBody active={collapseOpen1}>
            <p>
              Invia un email a <a href="mailto:info@formazionedocenti.it">info@formazionedocenti.it</a>
            </p>
            <p>ATTENZIONE : il Sistema non consente di rispondere alle email provenienti da indirizzi …@PEC.it e …@postecert.it</p>
          </AccordionBody>

          <AccordionHeader active={collapseOpen2} onToggle={() => this.toggle(2)}>
            <span className="text-green">Contatti telefonici</span>
          </AccordionHeader>
          <AccordionBody active={collapseOpen2}>
            <p>Recapiti telefonici dei nostri uffici:</p>
            <ul>
              <li>
                <a href="tel:0240707094">0240707094</a>
              </li>
            </ul>
          </AccordionBody>

          <AccordionHeader active={collapseOpen3} onToggle={() => this.toggle(3)}>
            <span className="text-green">Richiesta di contatto</span>
          </AccordionHeader>
          <AccordionBody active={collapseOpen3}>
            <p>
              Inserisci i tuoi dati e il momento in cui vuoi essere contattato. Sarai richiamato da un nostro operatore nella fascia oraria da te
              indicata.
            </p>
            <div>
              <ContactRequestForm aa={aa} />
            </div>
          </AccordionBody>

          <AccordionHeader active={collapseOpen4} onToggle={() => this.toggle(4)}>
            <span className="text-green">Whatsapp</span>
          </AccordionHeader>
          <AccordionBody active={collapseOpen4}>
            <p>Invia un messaggio e risponderemo in breve tempo</p>
            <div>
              <a className="text-green" href="https://wa.me/+393296553069" target="_blank" rel="noopener noreferrer">
                invia messaggio
              </a>
            </div>
          </AccordionBody>
        </Accordion>
      </MSection>
    );
  }
}
